import * as React from 'react';
import styled from 'styled-components/macro';
import { WithTranslation, withTranslation } from 'react-i18next';
import { formatMoney } from '../../../../helpers/formatters';

interface RevenueValueProps extends WithTranslation {
    amount: number;
    currency?: string;
    hideCurrency?: boolean;
}

const RevenueValue = (props: RevenueValueProps) => {
    const { hideCurrency = false, currency = 'NOK', amount } = props;
    const lng = props.i18n.language;
    if (hideCurrency) return (
        <Wrapper>
            <Value>{amount}</Value>
        </Wrapper>
    );
    return (
        <Wrapper>
            <Value>{formatMoney(lng, amount, currency)}</Value>
        </Wrapper>
    );
};

const Wrapper = styled.span`
    white-space: nowrap;
`;

const Value = styled.span`
    font-size: 23px;
    color: #495E61;
    font-weight: 700;
    
    @media (max-width: 1024px) {
        font-size: 16px;
    }
`;

export default withTranslation()(RevenueValue);
